(function($) {

  $(function() {

    if(
      $('body').hasClass('login-action-login')
      ||
      $('body').hasClass('login-action-lostpassword')
      ||
      $('body').hasClass('login-action-checkemail')
    ) {

      $('#user_login').attr('placeholder', 'E-mail')
      $('#user_pass').attr('placeholder', 'Contraseña')
      $('#login h1').remove()
      $('#login').prepend(`
        <div class="OlimpicGames">
        </div>
        <div class="Slogan">
          <div class="Title">
            Olimpiadas
          </div>
          <!-- div class="Corp">
          Zurich Agentes
          </div -->
        </div>
      `)
      /*$('p.forgetmenot').before(`
        <p class="aceptterms">
          <input 
            name="aceptterms" 
            type="checkbox" 
            id="aceptterms" 
            value="forever"
          > 
          <label for="aceptterms">
            Acepto las
            <a href="#">
              Condiciones de uso
            </a>
            y la
            <a href="https://zurich.playmotiv.cloud/politica-de-privacidad">
              Política de privacidad
            </a>
          </label>
        </p>
      `)*/
      $('.privacy-policy-page-link').remove()
      $('#lostpasswordform').prepend(`
        <div class="LostPasswordText">
          Introduce tu email y te enviaremos las
          instrucciones para restablecer tu contraseña
        </div>
      `)
      $('#login').children().wrapAll('<div id="LoginWrapper"></div>');
      
      $('#login').prepend(`
        <div class="BackLogoTorch">
          <div class="Explosion"></div>
          <div class="Torch"></div>
          <div class="Logo"></div>
        </div>
      `)
    }

    if($('body').hasClass('login-action-login')) {

      // $('#loginform .aceptterms').before($('#nav').remove())
    }

    if($('body').hasClass('login-action-lostpassword')) {

      $('#nav').addClass('RecoverPassword')

      $('#nav a').html('Volver')
    }

    $('.AcceptTerms a')
    .on(
      'click',
      function() {

        const privacyurl = $(this).attr('href')

        $('body')
        .append(`
          <div id="privacypopup">
            <div class="privacycontent">
              <iframe src="${ privacyurl }"></iframe>
              <div class="close">
                <img src="${ window.playmotivlogin.themeroot }/assets/icons/zurich/x.svg" />
              </div>
            </div>
          </div>
        `)
        $('#privacypopup .close')
        .on(
          'click',
          function() {

            $('#privacypopup').remove()
          }
        )

        return false
      }
    )

    const playmotivlogin = location.search.includes('playmotiv=1')
    if(playmotivlogin) {

      $('#loginform').show()
      $('#lostpasswordform').show()
      $('#nav').show()
      $('#azureoauth').hide()
    }
  })

})(jQuery)